import LinkBehavior from "./LinkBehavior";
import type { Theme } from "@mui/material";

const MuiButton = (theme: Theme) => ({
  defaultProps: {
    LinkComponent: LinkBehavior,
  },
  variants: [
    {
      props: { variant: "outlined", color: "inherit" },
      style: {
        border: "1px solid" + theme.palette.border,
        color: theme.palette.text.primary,
        "& .MuiButton-startIcon": {
          color: theme.palette.text.secondary,
        },
      },
    },
  ],
});
export default MuiButton;
